import { styled } from "styled-components";

export const List = styled.div`
    margin: 0;
    padding: 0;
`

export const ListItem = styled.div`

`

export const ListItemNumber = styled.span`
    border-right: 1px solid #fff;
    padding: 0 1rem;
    margin-right: 1rem;
`

export const ListItemHeader = styled.div`
    background-color: #000;
    color: #fff;
    padding: 0.25rem;
    display: flex;
    flex-direction: row;
`